import Icon from "@ant-design/icons";

const SVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="currentColor">
    <title></title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.0893 3.57757C13.4147 3.90301 13.4147 4.43065 13.0893 4.75609L7.84522 10.0002L13.0893 15.2442C13.4147 15.5697 13.4147 16.0973 13.0893 16.4228C12.7639 16.7482 12.2362 16.7482 11.9108 16.4228L6.07745 10.5894C5.75201 10.264 5.75201 9.73634 6.07745 9.41091L11.9108 3.57757C12.2362 3.25214 12.7639 3.25214 13.0893 3.57757Z"
    />
  </svg>
);

const ChevronLeftIcon = (props) => <Icon component={SVG} {...props} />;

export default ChevronLeftIcon;
